import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faSave, faPlus,faTrash, faLayerGroup, faArrowUp, faArrowDown, faChevronLeft, faSort, faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { AdminCommandResponse, SaveAdminCommandRequest, SaveAdminCommandResponse } from '../../data/CommandServiceDtos.generated';
import { PageContainerService, TimerService } from '../../services';
import { ProjectAccessArea, PROJECT_IDLE_TIMEOUT_MS } from '../../utilities/project-access-area';


@Component({
  standalone: false,
  selector: 'readiness-form-column-settings',
  templateUrl: './readiness-form-column-settings.component.html',
  styleUrls: ['./readiness-form-column-settings.component.scss'],
})
export class ReadinessFormColumnSettingsComponent implements OnInit, OnDestroy {
  faChevronLeft = faChevronLeft;
  faChevronDown = faChevronDown;
  faChevronRight = faChevronRight;
  faPlus = faPlus;
  faTrash = faTrash;
  titleValue: string = "Readiness Form Column Settings";
  projectId: number = 0;
  isAutoRouted: boolean = false;
  getCommandResponse: AdminCommandResponse = null;
  categoryToggle: { [key: string]: boolean } = {};
  groupedData: any[] = [];
  dragStartIndex: number | null = null;
  dragStartGroup: any = null;

  dragOverIndex: number | null = null;
  dragOverGroup: string | null = null;

  constructor(public pcs: PageContainerService, private route: ActivatedRoute, public timerService: TimerService) { }

  ngOnInit() {
    this.projectId = +this.route.snapshot.paramMap.get('id');
    this.pcs.apiService.LogTimeIn({ ProjectId: this.projectId, AccessArea: ProjectAccessArea.ReadinessSettings } as any, false, false);
    this.timerService.startIdleMonitor(PROJECT_IDLE_TIMEOUT_MS, () => {
      this.isAutoRouted = true;
      this.pcs.router.navigate(['/dashboard']);
    });
    this.loadData();

  }

  ngOnDestroy() {
    this.timerService.stopIdleMonitor();
    this.pcs.apiService.LogTimeOut({ ProjectId: this.projectId, IsAutoRouted: this.isAutoRouted, TimeOut: this.timerService.lastActivity, AccessArea: ProjectAccessArea.ReadinessSettings } as any, false, false);
  }

  async loadData() {
    this.getCommandResponse = null;
    this.groupedData = [];
    this.getCommandResponse = await this.pcs.apiService.Admin({ ProPakProjectId: this.projectId });

    if (this.getCommandResponse) {
      for (const sectionName in this.getCommandResponse) {
        if (
          this.getCommandResponse.hasOwnProperty(sectionName) &&
          sectionName !== 'ProjectPhases'
        ) {
          const sectionItems = this.getCommandResponse[sectionName];

          const mappedItems = sectionItems ? sectionItems.map((item: any) => ({
            Description: item.Description || 'Unnamed',
            Value: item.Value,
            Id: item.Id || 0,
            Order: item.Order || 0,
          })) : [];

          this.groupedData.push({
            sectionName: sectionName,
            data: mappedItems,
          });
        }
      }
    }
  }

  async saveAllTableData() {    
    const updatedRequest: any = {};

    for (const group of this.groupedData) {
      group.data.forEach((item, index) => {
        item.Order = index + 1;
      });

      updatedRequest[group.sectionName] = group.data.map(item => ({
        Id: item.Id,
        ProjectId: item.ProjectId,
        Description: item.Description,
        Value: item.Value,
        Order: item.Order
      }));
    }


    const response = await this.saveAdminData(updatedRequest);

    if (response) {
      await this.loadData();
    }
  }

  async saveAdminData(request: SaveAdminCommandRequest) {
    request.ProPakProjectId = this.projectId;
    const response: SaveAdminCommandResponse = await this.pcs.apiService.SaveAdmin(request, true, false);
    return this.processSaveResponse(response);
  }

  processSaveResponse(response: any) {
    if (response.IsRecordsUpdated) {
      void this.pcs.alert('Your changes have been saved successfully!', 'Saved', 'success');
      return true;
    }
    else {
      return false;
    }
  }
  toggleCategory(sectionName: string): void {
    this.categoryToggle[sectionName] = !this.categoryToggle[sectionName];
  }

  addRow(group: any) {
    group.data.push({
      Description: '',
      Value: null,
      isNew: true
    });
  }

  deleteRow(group: any, index: number) {
    group.data.splice(index, 1);
  }

  onDragStart(event: DragEvent, group: any, index: number) {
    this.dragStartIndex = index;
    this.dragStartGroup = group;
    if (event.dataTransfer) {
      event.dataTransfer.setData('text/plain', '');
    }
    event.dataTransfer!.effectAllowed = 'move';
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer!.dropEffect = 'move';
  }

  onDragEnter(event: DragEvent) {
    (event.target as HTMLElement).classList.add('drag-over');
  }

  onDragLeave(event: DragEvent) {
    (event.target as HTMLElement).classList.remove('drag-over');
  }

  onDrop(event: DragEvent, group: any, dropIndex: number) {
    event.preventDefault();

    if (this.dragStartGroup !== group) {
      return;
    }

    const dragIndex = this.dragStartIndex!;
    if (dragIndex === dropIndex) return;

    const movedItem = group.data.splice(dragIndex, 1)[0];
    group.data.splice(dropIndex, 0, movedItem);

    this.dragStartIndex = null;
    this.dragStartGroup = null;
    this.dragOverIndex = null;
    this.dragOverGroup = null;
  }

}
